var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconWhiteInsuranceApp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 37 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.282 19.922c0-9.042 6.028-16.673 14.281-19.106A19.925 19.925 0 0 0 19.922 0C8.92 0 0 8.92 0 19.922c0 11.003 8.92 19.922 19.922 19.922a19.93 19.93 0 0 0 5.641-.815c-8.254-2.433-14.281-10.064-14.281-19.107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.15 12.173c4.865 0 8.97 3.243 10.278 7.683.284-.962.438-1.98.438-3.035 0-5.917-4.797-10.714-10.715-10.714s-10.716 4.796-10.716 10.714c0 1.054.155 2.072.44 3.034 1.309-4.439 5.413-7.68 10.276-7.682"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.902 23.378a7.972 7.972 0 0 1-5.714 7.643 7.97 7.97 0 1 0 0-15.288 7.974 7.974 0 0 1 5.714 7.645"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhiteInsuranceApp);
export default __webpack_public_path__ + "static/media/icon-white-insurance-app.1c7127102677b433705fe2d16b37e1c3.svg";
export { ForwardRef as ReactComponent };